import { render } from "./app.vue?vue&type=template&id=6850f683&scoped=true"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"

import "./app.vue?vue&type=style&index=0&id=6850f683&lang=scss"
import "./app.vue?vue&type=style&index=1&id=6850f683&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6850f683"]])

export default __exports__